var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 220,
    viewBox: "0 0 242 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 0 0)",
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2153 137.841C29.7525 182.675 59.9809 207.668 116.812 207.668L130.194 207.652C175.215 207.599 215.16 185.405 225.828 137.841C229.751 120.346 229.79 108.438 229.649 98.6821C229.198 67.6721 199.6 44.2785 171.008 47.3437C162.617 48.0237 154.622 50.9595 147.596 55.5971L146.385 55.6038C126.241 53.9882 108.533 54.0479 92.5611 55.2985C84.0596 50.1932 74.216 47.5129 63.8355 48.0801C34.8201 49.8847 12.3386 73.3247 12.305 100.659C12.2898 112.2 12.1425 119.703 17.2153 137.841Z",
    fill: "#FFF2E4",
    stroke: "#2F80A2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.598 56.6877C130.68 69.2534 119.602 83.4323 120.541 107.897C120.477 118.566 119.919 128.24 120.541 138.889C120.892 144.176 121.726 150.193 123.608 155.119C125.42 160.082 128.301 163.626 133.27 166.859C124.129 162.258 122.46 155.985 121.093 147.904C119.699 140.005 119.727 131.911 119.76 123.91C119.818 117.282 119.937 110.525 119.955 103.89C119.943 81.4386 129.637 66.6356 147.598 56.6877Z",
    fill: "#2F80A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8375 56.6875C108.443 66.2745 119.175 79.4049 120.401 99.5641L120.508 101.548L120.544 103.532C120.569 110.083 120.544 116.751 120.367 123.293C119.919 135.308 120.038 151.036 113.177 160.878C111.698 162.972 109.121 165.246 107.01 166.547C109.087 165.19 111.012 162.461 112.449 160.355C116.734 153.919 118 146.746 118.879 139.013C120.09 127.257 119.928 115.358 119.953 103.538C119.995 81.6739 107.715 68.7297 92.8375 56.6875Z",
    fill: "#2F80A2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreech);
export default __webpack_public_path__ + "static/media/Breech.7dc99733bfa5e1f1253179b3904688a8.svg";
export { ForwardRef as ReactComponent };